import { jsx as _jsx } from "react/jsx-runtime";
import { useDashboard } from 'console/dashboards/z3k/provider';
import { useDashboardControl } from 'console/dashboards/z3k/provider/control';
import { sortByUISettings } from 'console/shared/content/ui-settings/utils';
import { isEqual } from 'lodash';
import { Fragment, memo, useMemo } from 'react';
import { ReactSortable } from 'react-sortablejs';
export const SmallUISortableDevices = memo(function SmallUISortableDevices(props) {
    const { devices, component } = props;
    const { dashboard_ui_settings, sorting_mode } = useDashboard();
    const { onDevicePositionChange } = useDashboardControl();
    const devices_list = useMemo(() => devices
        .filter(({ id }) => id != null)
        .map((device) => ({
        ...device,
        ui_settings: { ...dashboard_ui_settings[device.id] },
    }))
        .sort(sortByUISettings('position')), [dashboard_ui_settings, devices]);
    const devices_blocks = useMemo(() => devices_list.map(({ id }) => _jsx(Fragment, { children: component(id) }, id)), [devices_list]);
    return (_jsx(ReactSortable, { list: devices_list, setList: (devices) => {
            if (isEqual(devices, devices_list)) {
                return;
            }
            return onDevicePositionChange(devices);
        }, animation: 200, disabled: !sorting_mode, delay: 80, handle: ".dashboard-device-header", className: sorting_mode ? 'sortable-fallback' : undefined, scroll: true, scrollSpeed: 20, scrollSensitivity: 150, forceFallback: true, style: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: 8,
            paddingLeft: 8,
            paddingRight: 8,
        }, children: devices_blocks }));
});
